/** @jsx jsx */
import { jsx } from '@emotion/core';
// import React from 'react';
import { Formik } from 'formik';
import { PhoneNumber } from '../../../ui/Form';
import * as styles from './index.styles';

import Axios from 'axios';
import { SafePureComponent } from '../../../../utils/SafePureComponent';

export default class InputForm extends SafePureComponent {
  state = {
    alert: { msgType: '', msg: '' },
  };

  onSubmit = async values => {
    const { formSubmitAPI, formSuccessMsg, formFailMsg } = this.props;

    var phoneVal = this.countryData.DialingCode + values.phoneNumber;
    this.setState({
      alert: { msgType: '', msg: '' },
    });
    try {
      const result = await Axios.post(
        window.location.origin + '/' + formSubmitAPI,
        {
          phoneNumber: phoneVal,
        },
      );
      if (result.status == 200) {
        this.setState({
          alert: { msgType: 'success', msg: formSuccessMsg },
        });
        this.clearAlertMsg();
      } else {
        this.setState({
          alert: { msgType: 'error', msg: formFailMsg },
        });
        this.clearAlertMsg();
      }
    } catch (error) {
      this.setState({
        alert: { msgType: 'error', msg: formFailMsg },
      });
      this.clearAlertMsg();
    }
  };

  clearAlertMsg = () => {
    setTimeout(() => {
      this.setState({
        alert: { msgType: '', msg: '' },
      });
    }, 3000);
  };

  setCountryData = countryData => {
    this.countryData = countryData;
  };

  safeRender() {
    const { submitBtnLabel, PhoneNumberOptions, phoneRegExp } = this.props;

    const {
      alert: { msgType, msg },
    } = this.state;

    return (
      <Formik
        initialValues={{ phoneNumber: '' }}
        // validationSchema={validationSchema}
        validate={values => {
          const errors = {};

          // errors.phoneNumber = 'test';
          if (!values.phoneNumber) {
            errors.phoneNumber = 'Required';
          }

          // var phoneVal = this.countryData.DialingCode + values.phoneNumber;
          var phoneVal = values.phoneNumber;

          var patt = new RegExp(phoneRegExp);
          var isValid = patt.test(phoneVal);
          if (isValid === false) {
            errors.phoneNumber = 'Invalid Phone number';
          }
          return errors;
        }}
        onSubmit={this.onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="callmesec">
              <PhoneNumber
                options={PhoneNumberOptions}
                className="inputphone"
                // customCss={styles.inputCommon}
                innerCss={styles.phoneNumberFieldCssProps}
                id="phoneNumber"
                selectInputid="countryCode"
                // defaultValue={defaultPhoneValue}
                placeholder="Phone number*"
                onInit={({ countryData }) => this.setCountryData(countryData)}
                onChange={handleChange}
                onChangeProp={(_event, countryData) =>
                  this.setCountryData(countryData)
                }
                error={errors.phoneNumber && touched.phoneNumber}
                errorMessage={errors.phoneNumber}
                value={values.phoneNumber}
                inputProps={{
                  'data-testid': 'phone-input',
                  //   disabled: fieldDisabled,
                }}
                selectProps={{
                  'data-testid': 'phone-dropdown',
                  //   disabled: fieldDisabled,
                }}
              />

              {/* <button type="submit" disabled={isSubmitting}> */}
              <button type="submit">{submitBtnLabel}</button>
            </div>
            {msgType && (
              <div css={[styles.msgBox, msgType && styles[msgType]]}>{msg}</div>
            )}
          </form>
        )}
      </Formik>
    );
  }
}
